import { MetadataDependencyPanel } from '@common/Dependency/MetadataDependencyPanel';
import { DependencyType } from '@common/types/dependencyTypes';
import { Entity } from '@common/types/Entity';
import { BackEndCodeLanguageType } from '@prophecy/graphql-types/enums';
import { FROZEN_EMPTY_ARRAY } from '@prophecy/utils/constants';
import React, { useState } from 'react';

export function DependenciesTab({ projectId, language }: { projectId: string; language: BackEndCodeLanguageType }) {
  const [hasPanel, togglePanel] = useState(false);
  return (
    <MetadataDependencyPanel
      projectId={projectId}
      path={``}
      rootPanel={false}
      hasPanel={hasPanel}
      entity={Entity.Project}
      handleChange={() => null}
      language={language}
      dependencies={FROZEN_EMPTY_ARRAY as DependencyType[]}
      togglePanel={() => togglePanel(!hasPanel)}
    />
  );
}
